/**
 * Właściciel organizacji w panelu: lustro `isOrganizationOwner` z functions-shared
 * (organizationRole.ts, #81/#82). Właściciel to `organizations/{id}.owner == uid`
 * albo claim `owner` z id TEJ organizacji. Globalna rola `owner` (claim `role`,
 * nadawana każdemu przy logowaniu Google) nie mówi, którego hotelu ktoś jest
 * właścicielem, więc celowo jej nie uwzględniamy.
 */

/** Wartość `owner` (claim albo pole) obejmuje organizację: tablica id albo jedno id. */
export const ownsOrganization = (
  value: string[] | string | null | undefined,
  organizationId: string | null | undefined,
): boolean => {
  if (!organizationId || !value) return false;
  return Array.isArray(value) ? value.includes(organizationId) : value === organizationId;
};

export const isOrganizationOwner = (params: {
  uid: string | null | undefined;
  organizationId: string | null | undefined;
  /** `organizations/{id}.owner` bieżącej organizacji. */
  organizationOwner: string | null | undefined;
  /** Claim `owner` zalogowanego konta. */
  ownerClaim: string[] | string | null | undefined;
}): boolean => {
  if (!params.uid || !params.organizationId) return false;
  if (params.organizationOwner && params.organizationOwner === params.uid) return true;
  return ownsOrganization(params.ownerClaim, params.organizationId);
};

/**
 * Czy konto członka zespołu jest właścicielem JAKIEJKOLWIEK organizacji (backend:
 * `isAnyOrganizationOwner`). Panel widzi tylko `users/{uid}.owner` i właściciela
 * bieżącej organizacji; claimów i innych hoteli nie, resztę i tak pilnuje backend.
 */
export const isAnyOrganizationOwnerAccount = (params: {
  memberId: string;
  memberOwner: string[] | string | null | undefined;
  organizationOwner: string | null | undefined;
}): boolean => {
  if (params.organizationOwner && params.organizationOwner === params.memberId) return true;
  const value = params.memberOwner;
  return Array.isArray(value) ? value.length > 0 : typeof value === 'string' && value !== '';
};
